import apiService from './apiService.js';

const resource = '/depth_charts';

export default {
    getAddableDepthChartList() {
        return apiService.get(`${resource}/addable_people`);
    },
    getRemovableDepthChartList() {
        return apiService.get(`${resource}/my_people`);
    },
    addDepthChart(personId, depthChartColumnId) {
        return apiService.post(`${resource}`,
            {
                chart_member_id: personId,
                depth_chart_column_id: depthChartColumnId
            });
    },
    transferDepthChart(chartMemberId, depthChartColumn) {
        return apiService.post(`${resource}/transfer`,
            {
                chart_member_id: chartMemberId,
                depth_chart_column: depthChartColumn
            });
    },
    removeDepthChart(personId) {
        return apiService.delete(`${resource}/${personId}`);
    },
};
